import React, { Fragment, useEffect, useState } from "react";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import "./AssetDetailedView.scss";
import PersonSharpIcon from "@mui/icons-material/PersonSharp";
import {
  Button,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  fetchBusinessUnit,
  fetchBusinessUnitPreference,
} from "../../services/orgService";
import { checkPermissions, dateParser, isMultiSources } from "../../helper";
import { getAssetService } from "../../services/assetService";
import { assetServer } from "../../server-data";
import { STEPS } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getEmissionListService } from "../../services/emissionService";
import EmptyList from "../common/EmptyList";
const AssetDetailedView = (props: any) => {
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const {
    assetData,
    onClose,
    controller,
    total_count,
    currentIndex,
    navigateNext,
    categoryPreferences,
    categoryData,
    scope,
  } = props;
  const { page, limit } = controller;
  const [transactionController, setTransactionController] = useState({
    page: 0,
    limit: 10,
  });
  const [step, setStep] = useState(STEPS.DETAILS);
  let index = limit * page + currentIndex;
  const navigate = useNavigate();
  const [assetDetailedItem, setAssetDetailedItem] = useState<any>({});
  const { t, i18n } = useTranslation();
  const [emissionTransactionList, setEmissionTransactionList] = useState(
    [] as any
  );
  useEffect(() => {
    getAssetService({ id: assetData.id })
      .then((res: any) => {
        let assetDetailedItem = res.data.asset;
        setAssetDetailedItem(assetDetailedItem);
      })
      .catch((err) => {
        console.log(err);
      });
    const reqObj: any = {
      controller: transactionController,
      asset: assetData.id,
    };
    getEmissionListService(reqObj).then((res) => {
      let emissionTransactionList = res?.data?.emissionsList;
      if (emissionTransactionList) {
        setEmissionTransactionList(emissionTransactionList);
      }
    });
  }, [index]);

  const getUomName = (symbol: string) => {
    const parts = symbol?.split("/");
    if (parts?.length > 1) {
      return parts[parts?.length - 1];
    } else {
      return symbol;
    }
  };

  let cellColumns = [
    "Emission ID",
    "Value(kg CO2e)",
    "Modified on",
    "Modified by",
  ];
  const openEdit = () => {
    navigate("/asset/" + assetData.id, {
      state: {
        assetDetailedItem: assetDetailedItem,
        categoryPreferences: categoryPreferences,
        categoryData: categoryData,
        scope: scope,
      },
    });
  };
  const onNavigateNext = (increment: number) => {
    if (increment > 0 && currentIndex === limit - 1) {
      navigateNext(increment, 1);
    } else if (increment < 0 && currentIndex === 0) {
      navigateNext(increment, -1);
    } else {
      navigateNext(increment, 0);
    }
  };

  return (
    <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main">
      {/* <div className="flex flex-row items-center"> */}
      <div className="flex flex-row items-center pw-justify-space-between gap-6 p-2 px-4">
        <div className="flex flex-row items-start pw-justify-space-between gap-6">
          <p
            className={`text-sm cursor-pointer pw-border-bottom pt-1 ${
              step === STEPS.DETAILS ? "pw-tab" : ""
            }`}
            onClick={() => {
              setStep(STEPS.DETAILS);
            }}
          >
            {t("Details")}
          </p>
          <p
            className={`text-sm cursor-pointer pw-border-bottom pt-1 ${
              step === STEPS.TRANSACTIONS ? "pw-tab" : ""
            }`}
            onClick={() => {
              setStep(STEPS.TRANSACTIONS);
            }}
          >
            {t("Emission transactions")}
          </p>
        </div>
        <div className="pw-bunit-detailed-header flex justify-end gap-3 pr-2">
          {checkPermissions(["UPDATE_MULTIPLE_ASSETS"], permissions) ? (
            <Button onClick={openEdit} className="pw-editbox-emission">
              <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
              <div className="pw-edit">{t("Edit")}</div>
            </Button>
          ) : (
            ""
          )}

          {index > 0 && (
            <div
              onClick={() => onNavigateNext(-1)}
              className="pw-navigate-next pw-padding-5"
            >
              <img src="assets/icons/prev.svg" alt=" " />
            </div>
          )}
          {index < total_count - 1 && (
            <div
              onClick={() => onNavigateNext(1)}
              className="pw-navigate-next pw-padding-5 pw-bunit-next"
            >
              <img src="assets/icons/next.svg" alt=" " />
            </div>
          )}

          <div
            onClick={() => onClose()}
            className="pw-navigate-next items-center"
          >
            <CloseIcon className=" items-center text-neutral-600" />
          </div>
        </div>
      </div>

      {step === STEPS.DETAILS && (
        <Fragment>
          <div className="w-full p-6 my-4 bg-white rounded-lg shadow flex-col justify-start items-start gap-6 inline-flex">
            <div className="self-stretch text-slate-400 text-xs font-bold uppercase">
              {t("Basic info")}
            </div>
            <div className="self-stretch justify-start items-start gap-2 inline-flex">
              <div className="flex-col justify-start items-start gap-6 inline-flex">
                <div className="flex-col justify-start items-start gap-6 flex">
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Asset ID")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-bold"
                      id="pw-e2e-dv-assetid"
                    >
                      {assetDetailedItem.local_code
                        ? assetDetailedItem.local_code
                        : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Asset type")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-bold"
                      id="pw-e2e-dv-assetype"
                    >
                      {assetDetailedItem.type ? assetDetailedItem.type : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Name")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetname"
                    >
                      {assetDetailedItem.name ? assetDetailedItem.name : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Owner")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetowner"
                    >
                      {assetDetailedItem.owner_ship
                        ? assetDetailedItem.owner_ship
                        : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Status")}:
                    </div>
                    <div
                      className={`${
                        !assetDetailedItem.disabled
                          ? "text-green-400 text-sm font-bold"
                          : "text-neutral-400 text-sm font-bold"
                      }`}
                      id="pw-e2e-dv-assetstatus"
                    >
                      {assetDetailedItem.disabled ? "InActive" : "Active"}{" "}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Description")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetdescrption"
                    >
                      {assetDetailedItem.description
                        ? assetDetailedItem.description
                        : "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full p-6 my-4 bg-white rounded-lg shadow flex-col justify-start items-start gap-6 inline-flex">
            <div className="self-stretch text-slate-400 text-xs font-bold uppercase">
              {t("Asset Mapping")}
            </div>
            <div className="self-stretch justify-start items-start gap-2 inline-flex">
              <div className="flex-col justify-start items-start gap-6 inline-flex">
                <div className="flex-col justify-start items-start gap-6 flex">
                  <div className="flex flex-row gap-6">
                    <div className=" w-48 text-slate-500 text-sm font-normal">
                      {t("Emission Category")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-emissioncategory"
                    >
                      {assetDetailedItem?.emission_category_code +
                        "-" +
                        assetDetailedItem?.emission_category}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-48 text-slate-500 text-sm font-normal">
                      {t("Emission Factor Source")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetemissionfactorsource"
                    >
                      {assetDetailedItem?.emission_type +
                        "-" +
                        (assetDetailedItem?.emission_sub_type
                          ? assetDetailedItem?.emission_sub_type
                          : "")}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-48 text-slate-500 text-sm font-normal">
                      {t("Log Emission Against")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetlogemissionagainst"
                    >
                      {assetDetailedItem?.emission_method}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-48 text-slate-500 text-sm font-normal">
                      {t("Activity Data")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetactivitydata"
                    >
                      {assetDetailedItem?.emission_source +
                        " " +
                        (assetDetailedItem?.emission_sub_source
                          ? assetDetailedItem?.emission_sub_source
                          : " ") +
                        " " +
                        (assetDetailedItem?.engine
                          ? assetDetailedItem?.engine
                          : " ") +
                        " " +
                        (assetDetailedItem?.fuel
                          ? assetDetailedItem?.fuel
                          : " ")}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-48 text-slate-500 text-sm font-normal">
                      {t("Uom")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetuom"
                    >
                      {getUomName(assetDetailedItem?.uom_name)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full h-80 p-6 my-4 bg-white rounded-lg shadow flex-col justify-start items-start gap-6 inline-flex">
            <div className="self-stretch text-slate-400 text-xs font-bold uppercase">
              {t("Additional info")}
            </div>
            <div className="self-stretch justify-start items-start gap-2 inline-flex">
              <div className="flex-col justify-start items-start gap-6 inline-flex">
                <div className="flex-col justify-start items-start gap-6 flex">
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Location")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetlocation"
                    >
                      {assetDetailedItem.location
                        ? assetDetailedItem.location
                        : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Department")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetdepartment"
                    >
                      {assetDetailedItem.department_name
                        ? assetDetailedItem.department_name
                        : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Category")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetcategory"
                    >
                      {assetDetailedItem.category_name
                        ? assetDetailedItem.category_name
                        : "-"}
                    </div>
                  </div>
                  {/* <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("No. of units")}:
                    </div>
                    <div className="text-neutral-800 text-sm font-normal">
                      {assetDetailedItem.no_of_units
                        ? assetDetailedItem.no_of_units
                        : "-"}
                    </div>
                  </div> */}
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Value")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetvalue"
                    >
                      {assetDetailedItem.value
                        ? assetDetailedItem?.currency_name +
                          " " +
                          assetDetailedItem.value
                        : "-"}
                    </div>
                  </div>
                  <div className="flex flex-row gap-6">
                    <div className=" w-20 text-slate-500 text-sm font-normal">
                      {t("Notes")}:
                    </div>
                    <div
                      className="text-neutral-800 text-sm font-normal"
                      id="pw-e2e-dv-assetnotes"
                    >
                      {assetDetailedItem.notes ? assetDetailedItem.notes : "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )}

      {step === STEPS.TRANSACTIONS && (
        <div
          className={`${
            !emissionTransactionList?.length
              ? "flex justify-center items-center h-full"
              : ""
          }`}
        >
          {emissionTransactionList?.length ? (
            <div className="h-70v overflow-y-auto">
              <Card>
                <Table size="small" className="pw-bunit-table">
                  <TableHead className="pw-blist-head bg-neutral-50">
                    <TableRow className="h-14">
                      {cellColumns.map((eachCell, index) => (
                        <TableCell key={index} className="pw-thead-list">
                          {t(eachCell)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {emissionTransactionList.map(
                      (eachEmission: any, index: number) => (
                        <TableRow
                          key={eachEmission.id}
                          // onClick={(e) => onSelectBunit(e, index)}
                          className={` ${
                            eachEmission.selected
                              ? "bg-primary-100"
                              : "bg-white"
                          } h-14`}
                        >
                          <TableCell className="pw-bunit-padding pw-bunit-width">
                            {" "}
                            {eachEmission.id}{" "}
                          </TableCell>
                          <TableCell className="pw-bunit-padding pw-bunit-width">
                            {" "}
                            {eachEmission.value}{" "}
                          </TableCell>
                          <TableCell className="pw-bunit-padding pw-bunit-width">
                            {" "}
                            {dateParser(eachEmission.last_updated)}{" "}
                          </TableCell>
                          <TableCell className="pw-bunit-padding pw-bunit-width">
                            {" "}
                            {eachEmission.last_updated_by_name}{" "}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </Card>
            </div>
          ) : (
            <div className="m-4 p-4 flex justify-center items-center">
              {t("No Emission transactions found with this asset")}
            </div>
          )}
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

// BusinessUnitDetailedView.propTypes = {}

export default AssetDetailedView;
